/* TEAM VITAL — global.js */

document.addEventListener('DOMContentLoaded', () => {
  // Mobile menu
  const toggle = document.querySelector('.tv-menu-toggle');
  const nav = document.querySelector('.tv-nav');
  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // Product form variant handling
  document.querySelectorAll('[data-product-form]').forEach((wrapper) => {
    const productJson = wrapper.querySelector('[data-product-json]');
    if (!productJson) return;
    const product = JSON.parse(productJson.textContent);
    const selects = wrapper.querySelectorAll('[data-option-select]');
    const idInput = wrapper.querySelector('[name="id"]');
    const priceEl = wrapper.querySelector('[data-price]');
    const comparePriceEl = wrapper.querySelector('[data-compare-price]');
    const buyBtn = wrapper.querySelector('[data-add-to-cart]');

    const money = (cents) => {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: window.Shopify && Shopify.currency ? Shopify.currency.active : 'USD'
      }).format(cents / 100);
    };

    const updateVariant = () => {
      const chosen = Array.from(selects).map((s) => s.value);
      const variant = product.variants.find((v) =>
        v.options.every((opt, i) => opt === chosen[i])
      );
      if (!variant) return;
      idInput.value = variant.id;
      if (priceEl) priceEl.textContent = money(variant.price);
      if (comparePriceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          comparePriceEl.textContent = money(variant.compare_at_price);
          comparePriceEl.hidden = false;
        } else {
          comparePriceEl.hidden = true;
        }
      }
      if (buyBtn) {
        buyBtn.disabled = !variant.available;
        buyBtn.textContent = variant.available
          ? buyBtn.dataset.labelAdd
          : buyBtn.dataset.labelSoldOut;
      }
      // Update URL ?variant=
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    };

    selects.forEach((s) => s.addEventListener('change', updateVariant));
  });

  // AJAX add to cart
  document.querySelectorAll('form[data-ajax-cart]').forEach((form) => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('[data-add-to-cart]');
      const original = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = btn.dataset.labelAdding || 'Adding…'; }
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: form.querySelector('[name="id"]').value,
            quantity: parseInt(form.querySelector('[name="quantity"]')?.value || '1', 10)
          })
        });
        if (!res.ok) throw new Error('Add to cart failed');
        const cart = await fetch('/cart.js').then((r) => r.json());
        document.querySelectorAll('[data-cart-count]').forEach((el) => {
          el.textContent = cart.item_count;
        });
        if (btn) btn.textContent = btn.dataset.labelAdded || 'Added ✓';
        setTimeout(() => { if (btn) { btn.textContent = original; btn.disabled = false; } }, 1600);
      } catch (err) {
        if (btn) { btn.textContent = original; btn.disabled = false; }
        window.location.href = '/cart';
      }
    });
  });
});
